import { render, staticRenderFns } from "./downItem.vue?vue&type=template&id=6c381a4a"
import script from "./downItem.vue?vue&type=script&lang=js"
export * from "./downItem.vue?vue&type=script&lang=js"
import style0 from "./downItem.vue?vue&type=style&index=0&id=6c381a4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports